export const MISSING_DATA_TEXT = "Not provided";
export const MISSING_LABEL_DATE_TEXT = "No date provided";
export const EXAMPLE_REQUEST_ID = "example";
